import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-md"
      >
        <Card className="bg-background-paper border-border">
          <CardContent className="p-8 text-center">
            <div className="w-20 h-20 rounded-full bg-accent-warning/20 flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-10 h-10 text-accent-warning" />
            </div>
            <h2 className="font-heading font-bold text-xl text-text-primary mb-2">
              Payment Cancelled
            </h2>
            <p className="text-text-secondary mb-6">
              Your payment was cancelled. No charges were made to your account.
            </p>
            <div className="space-y-3">
              <Button
                onClick={() => navigate("/dashboard")}
                className="w-full bg-primary hover:bg-primary-hover text-white"
              >
                Return to Dashboard
              </Button>
              <Button
                onClick={() => navigate(-1)}
                variant="outline"
                className="w-full border-border"
              >
                Try Again
              </Button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}
